// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --padding-bottom: 15%;
}

ion-spinner {
  margin: 10px 0;
}

h5 {
  font-weight: bold;
}

.attendee-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 3px 0;
  margin: 0 20px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
}
.attendee-item:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.attendee-item .user-icon-container {
  display: flex;
}
.attendee-item .user-icon-container .user-icon {
  font-size: 36px;
  color: #ed143d;
}
.attendee-item ion-label {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.attendee-item .attendee-item-actions {
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
}
.attendee-item .attendee-item-actions ion-badge {
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 10px;
}
.attendee-item .attendee-item-actions .close-icon-container {
  display: flex;
}
.attendee-item .attendee-item-actions .close-icon-container ion-icon {
  font-size: 24px;
  color: #ed143d;
}

ion-searchbar {
  --background: white;
  --icon-color: #ed143d;
  --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);
  padding: 5px 10px;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/add-attendee/add-attendee.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AACA;EACE,iBAAA;AAEF;;AAAA;EAIE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAVE;EACE,gCAAA;AAYJ;AAFE;EACE,aAAA;AAIJ;AAHI;EACE,eAAA;EACA,cAAA;AAKN;AAFE;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAIJ;AAFE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;AAIJ;AAHI;EACE,gBAAA;EACA,kBAAA;EACA,eAAA;AAKN;AAHI;EACE,aAAA;AAKN;AAJM;EACE,eAAA;EACA,cAAA;AAMR;;AAAA;EACE,mBAAA;EACA,qBAAA;EACA,8CAAA;EACA,iBAAA;EACA,wBAAA;EAAA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;AAGF","sourcesContent":["ion-content {\n  --padding-bottom: 15%;\n}\n\nion-spinner {\n  margin: 10px 0;\n}\nh5 {\n  font-weight: bold;\n}\n.attendee-item {\n  &:not(:last-child) {\n    border-bottom: 1px solid #e0e0e0;\n  }\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 3px 0;\n  margin: 0 20px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 4px;\n  .user-icon-container {\n    display: flex;\n    .user-icon {\n      font-size: 36px;\n      color: #ed143d;\n    }\n  }\n  ion-label {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n  }\n  .attendee-item-actions {\n    display: flex;\n    gap: 5px;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    margin-left: auto;\n    ion-badge {\n      padding: 6px 8px;\n      border-radius: 6px;\n      font-size: 10px;\n    }\n    .close-icon-container {\n      display: flex;\n      ion-icon {\n        font-size: 24px;\n        color: #ed143d;\n      }\n    }\n  }\n}\n\nion-searchbar {\n  --background: white;\n  --icon-color: #ed143d;\n  --box-shadow: 0 2px 0px 0px rgba(0, 0, 0, 0.2);\n  padding: 5px 10px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
